import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Native checkbox + label, styled to match the Unify form-control palette.
 * Drop-in replacement for `@nearst/ui`'s `CheckboxInput` — same
 * `{ label, labelClassName, ...inputProps }` API.
 */
export const Checkbox = React.forwardRef(({ className, label = '', labelClassName, ...props }, ref) => (
	<label className={cn('inline-flex items-center gap-2 text-sm text-foreground', className)}>
		<input
			ref={ref}
			type="checkbox"
			className="h-4 w-4 cursor-pointer rounded border-input text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
			{...props}
		/>
		{label ? <span className={labelClassName}>{label}</span> : null}
	</label>
));
Checkbox.displayName = 'Checkbox';
